module.exports = __webpack_public_path__ + "img/isk.60bb31cc.png";